import Color from 'color';
import { MD3LightTheme } from 'react-native-paper';
import { paperAppColors as c } from './paperThemeColors';
/**
 * AbbisWay light theme for React Native Paper: MD3 roles + app tokens on `colors`.
 */
function buildElevation(primary, surface) {
    const mix = (t) => Color(primary).mix(Color(surface), t).rgb().string();
    return {
        level0: 'transparent',
        level1: mix(0.94),
        level2: mix(0.91),
        level3: mix(0.88),
        level4: mix(0.86),
        level5: mix(0.84),
    };
}
export const paperLightTheme = {
    ...MD3LightTheme,
    colors: {
        ...MD3LightTheme.colors,
        primary: c.actionPrimary,
        onPrimary: c.textOnPrimary,
        primaryContainer: c.validationChipBackground,
        onPrimaryContainer: c.infoTextEmphasis,
        secondary: c.actionSecondary,
        onSecondary: c.textOnPrimary,
        secondaryContainer: c.surfaceBlueTint,
        onSecondaryContainer: c.textPrimary,
        tertiary: c.photoItemAccent,
        onTertiary: c.textOnPrimary,
        tertiaryContainer: c.surfaceElevatedMuted,
        onTertiaryContainer: c.textPrimary,
        surface: c.surfaceElevated,
        surfaceVariant: c.surfaceElevatedMuted,
        surfaceDisabled: Color(c.textPrimary).alpha(0.12).rgb().string(),
        background: c.backgroundScreen,
        onBackground: c.textPrimary,
        error: c.danger,
        errorContainer: c.dangerBackground,
        onError: c.textOnPrimary,
        onErrorContainer: c.dangerText,
        onSurface: c.textPrimary,
        onSurfaceVariant: c.textSecondary,
        onSurfaceDisabled: Color(c.textPrimary).alpha(0.38).rgb().string(),
        outline: c.borderDefault,
        outlineVariant: c.borderSubtle,
        inverseSurface: c.textHeading,
        inverseOnSurface: c.textInverse,
        inversePrimary: c.actionPrimaryAlt,
        scrim: c.overlayFab,
        backdrop: Color(c.textPrimary).alpha(0.32).rgb().string(),
        elevation: buildElevation(c.actionPrimary, c.surfaceElevated),
        ...c,
    },
};
